<template>
  <div class="num-scroll-wrapper">
    <span
      class="got-num"
      :class="{
        'got-num-hide-animation': hideAnimation
      }"
      v-for="(item, index) in numProcessed[0]"
      :key="'prepend'+(numProcessed[0].length - index)"
      :style="`top: ${scrollTo[0][index] * 30}px`"
    >
      <span class="faker">8</span>
      <span
        v-for="(item, i) in fakerNums[0][index]"
        :key="'prependSub'+item"
        class="num"
        :class="{ 'num-really': i === scrollTo[0][index]}"
        :style="'top: -' + i * 30 + 'px'"
      >{{item}}</span>
    </span>
    <span class="got-num" style="width: 10px" v-if="numProcessed.length > 1">.</span>
    <span
      class="got-num"
      :class="{
        'got-num-hide-animation': hideAnimation
      }"
      v-for="(item, index) in numProcessed[1]"
      :key="'append'+ index"
      :style="`top: ${scrollTo[1][index] * 30}px`"
    >
      <span class="faker">8</span>
      <span
        v-for="(item, i) in fakerNums[1][index]"
        :key="'appendSub'+item"
        class="num"
        :class="{ 'num-really': i === scrollTo[1][index]}"
        :style="'top: -' + i * 30 + 'px'"
      >{{item}}</span>
    </span>
  </div>
</template>

<script>
/* eslint-disable */
import { prefixStyle } from 'cube-ui/src/common/helpers/dom'
const transform = prefixStyle('transform')
export default {
  props: {
    num: {
      type: [String, Number],
      default: 0
    }
  },
  watch: {
    num: {
      handler(newV) {
        if (this.selfNumDigit === -1) {
          const temp = ('' + newV).split('.')
          if (temp.length === 2) {
            this.selfNumDigit = new Array(temp[0].length).fill(0).join('') + '.' + new Array(temp[1].length).fill(0).join('')
          } else {
            this.selfNumDigit = new Array(temp[0].length).fill(0).join('')
          }
          this.selfNum = newV + ''
          this.numProcessedHandler()
          this.fakerNumsHandler()
          this.scrollToHandler()
        } else {
          this.hideAnimation = false
          this.showAnimation()
          setTimeout(() => {
            this.selfNum = newV + ''
            this.selfNumDigit = newV + ''
            this.numProcessedHandler()
            this.fakerNumsHandler()
            this.hideAnimation = true
            this.scrollToHandler()
          }, 2000)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      selfNum: -1,
      selfNumDigit: -1,
      numProcessed: [],
      fakerNums: [],
      scrollTo: [],
      hideAnimation: false,
      transformKey: transform
    }
  },
  methods: {
    showAnimation() {
      const newNum = this.num + ''
      const newNumSplit = newNum.split('.')
      const slefNumSplit = this.selfNumDigit.split('.')
      if (newNumSplit.length === 1) {
        this.selfNum = this.selfNum.split('.')[0]
        if (newNumSplit[0].length !== slefNumSplit[0].length) {
          for (let i = 0; i < newNumSplit[0].length - slefNumSplit[0].length; i++) {
            this.selfNum = '0' + this.selfNum
            this.scrollTo[0].unshift(0)
          }
        }
      } else {
        if (newNumSplit[0].length !== slefNumSplit[0].length) {
          for (let i = 0; i < newNumSplit[0].length - slefNumSplit[0].length; i++) {
            this.selfNum = '0' + this.selfNum
            this.scrollTo[0].unshift(0)
          }
        }
        if (newNumSplit[1].length !== slefNumSplit[1].length) {
          for (let i = 0; i < newNumSplit[1].length - slefNumSplit[1].length; i++) {
            this.selfNum = this.selfNum + '0'
            this.scrollTo[1].push(0)
          }
        }
      }
      this.numProcessedHandler()
      this.fakerNumsHandler()
      setTimeout(() => {
        this.scrollToHandler()
      }, 0)
    },
    numProcessedHandler() {
      const num = '' + this.selfNum
      if (num.includes('.')) {
        const temp = num.split('.')
        this.numProcessed = [temp[0].split(''), temp[1].split('')]
      } else {
        this.numProcessed = [num.split('')]
      }
    },
    fakerNumsHandler() {
      const numProcessed = this.numProcessed
      const arr = numProcessed.map(item => {
        return item.map(num => {
          const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
          const after = nums.splice(~~num)
          after.push(...nums)
          return after
        })
      })
      this.fakerNums = arr
    },
    scrollToHandler() {
      const num = this.num + ''
      const fakerNums = this.fakerNums
      const temp = num.split('.')
      this.scrollTo = temp.map((item, index) => {
        return item.split('').map((i, j) => {
          return fakerNums[index][j].indexOf(~~i)
        })
      })
    }
  }
}
</script>

<style lang="stylus">
.num-scroll-wrapper
  position: relative
  top: -2px
  display: flex
  overflow: hidden
  .got-num
    position: relative
    display: flex
    flex-direction: column
    height: 6.4vw
    color: #FC4A00
    font-weight: bold
    font-size: 6.4vw
    font-family: 'dinum'
    transition: top 2s
  .faker
    visibility: hidden
    // 用于撑开父元素
    opacity: 0
  .got-num-hide-animation
    transition: none
  .num
    position: absolute
    top: 0px
    left: 50%
    transform: translateX(-50%)
</style>
